import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { CustomerType } from "../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { Organisation } from "../../../../../Wrap/Models/Models/Customer/Organisation";
import { Company } from "../../../../../Wrap/Models/Models/Customer/Company";
import { Permission } from "../../../../Shared/Permission/Permission";
import { Tab } from "../../../../Shared/Tab/Tab";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import { Addresses } from "./Addresses";
import { CompanyDetails } from "./CompanyDetail";
import { HeaderBar } from "./Components/HeaderBar";
import { ContactDetails } from "./ContactDetails";
import { OrganisationDetails } from "./OrganisationDetails";
import { PensionProtection } from "./PensionProtection";
import { PersonalDetails } from "./PersonalDetails";
import { Regulatory } from "./Regulatory";
import { RegulatoryChecks } from "./RegulatoryChecks";
import {
    ClientRecordTab,
    AllClientRecordTabs,
    CompanyClientRecordTabs,
    IndividualClientRecordTabs,
    OrganisationClientRecordTabs,
} from "./Resource/Contents";
import { ClientRecordStore } from "./Store/Variable";
import { TrustServicing } from "./TrustServicing";
import { ContextStore } from "../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../Wrap/Constants/Enums/ContextType";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { PermissionAction } from "../../../../Shared/Permission/Action/PermissionAction";
import { UserStore } from "../../../Stroes/Variable";

interface IClientRecordProps extends React.Props<ClientRecord> {}

interface IClientRecordState {
    data?: any;
    tabIndex: ClientRecordTab;
    customerType: CustomerType;
    name: string;
    hasReadWriteAccessToAdviser: boolean;
}

export class ClientRecord extends FormComponent<IClientRecordProps, IClientRecordState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            tabIndex: this.getTabIndex(),
            customerType: null,
            name: "",
            hasReadWriteAccessToAdviser: true,
        };
        this.subscribeToStore(ClientRecordStore, () => this.onStoreChange());
    }

    componentDidMount() {
        const customerId = this.getCustomerId();
        PermissionAction.checkUserHavePermissionForAdviserByActor(Number(customerId), (data) => {
            this.setState({ hasReadWriteAccessToAdviser: data?.IsReadOnly != true });
        });
        ClientRecordAction.getAccountRoleDetail(customerId);
        ClientRecordAction.getPersonalDetail(customerId);
        ClientRecordAction.getOrganisationDetail(customerId);
        ClientRecordAction.getCompanyDetail(customerId);
    }

    public componentWillReceiveProps() {
        const tabIndex = this.getTabIndex();
        if (tabIndex !== this.state.tabIndex) {this.getContent(tabIndex, this.getCustomerId());}
    }

    private getCustomerId() {
        return HierarchyIdHelper.generateHierarchyId(
            ContextStore.getUrlParamsHierarchyId(ContextType.Customer)
        ).entityId?.toString();
    }

    private getTabIndex(): ClientRecordTab {
        const i = window.location.pathname.lastIndexOf("/");
        const path = window.location.pathname.substr(i + 1);
        if (CommonHelper.isNullOrEmpty(path) || path.toLowerCase() == "detail") {return null;}
        const tabs = AllClientRecordTabs;
        let tabIndex: ClientRecordTab = null;
        tabs.forEach((element: string) => {
            if (element.toLowerCase() === path.toLowerCase().replace("-", " ")) {
                tabIndex = element as ClientRecordTab;
            }
        });
        return tabIndex;
    }

    private onStoreChange() {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.PersonalDetail])) {
            this.setState({
                customerType: CustomerType.Individual,
                name: `${data[ClientRecordTab.PersonalDetail]?.GivenName} ${
                    data[ClientRecordTab.PersonalDetail]?.FamilyName
                }`,
            });
        }
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation: Organisation = data[ClientRecordTab.OrganisationDetails];
            if (organisation?.CustomerType && organisation?.CustomerType !== CustomerType.Company) {
                this.setState({
                    customerType: organisation.CustomerType,
                    name: data[ClientRecordTab.OrganisationDetails]?.Name,
                });
            } else {
                if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.CompanyDetails])) {
                    const company: Company = data[ClientRecordTab.CompanyDetails];
                    this.setState({
                        customerType: CustomerType.Company,
                        name: company?.CompanyName,
                    });
                }
            }
        }
    }

    public getContent(key: ClientRecordTab, id: string) {
        if (!key) {return null;}
        let _content = null;
        const hasReadOnlyAccess =
            this.state?.hasReadWriteAccessToAdviser == true && UserStore.getUserInfo()?.IsReadOnly == false;
        switch (key) {
            case ClientRecordTab.PersonalDetail:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <PersonalDetails id={id} hasReadWriteAccess={hasReadOnlyAccess} />
                    </Permission>
                );
                break;
            case ClientRecordTab.OrganisationDetails:
                if (this.state.customerType === CustomerType.Company) {
                    _content = (
                        <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                            <CompanyDetails
                                id={id}
                                customerType={this.state.customerType}
                                hasReadWriteAccess={hasReadOnlyAccess}
                            />
                        </Permission>
                    );
                } else {
                    _content = (
                        <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                            <OrganisationDetails
                                id={id}
                                customerType={this.state.customerType}
                                data={null}
                                onChange={() => {}}
                                onRef={() => {}}
                                hasReadWriteAccess={hasReadOnlyAccess}
                            />
                        </Permission>
                    );
                }
                break;
            case ClientRecordTab.RegulatoryChecks:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerFullyAccessCanView}>
                        <RegulatoryChecks id={id} hasReadWriteAccess={hasReadOnlyAccess} />
                    </Permission>
                );
                break;
            case ClientRecordTab.Regulatory:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <Regulatory id={id} hasReadWriteAccess={hasReadOnlyAccess} />
                    </Permission>
                );
                break;
            case ClientRecordTab.AddressDetail:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <Addresses
                            id={id}
                            customerType={this.state.customerType}
                            hasReadWriteAccess={hasReadOnlyAccess}
                        />
                    </Permission>
                );
                break;
            case ClientRecordTab.ContactDetail:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <ContactDetails
                            id={id}
                            customerType={this.state.customerType}
                            hasReadWriteAccess={hasReadOnlyAccess}
                        />
                    </Permission>
                );
                break;
            case ClientRecordTab.PensionProtection:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <PensionProtection id={id} hasReadWriteAccess={hasReadOnlyAccess} />
                    </Permission>
                );
                break;
            case ClientRecordTab.TrustServicing:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <TrustServicing id={id} hasReadWriteAccess={hasReadOnlyAccess} />
                    </Permission>
                );
                break;
        }
        return _content;
    }

    private getTabArray = (customerType: CustomerType): ClientRecordTab[] => {
        let tabs = [];

        if (customerType == CustomerType.Individual) {
            tabs = IndividualClientRecordTabs;
        } else if (customerType == CustomerType.Trust || customerType == CustomerType.CorporateTrust) {
            tabs = OrganisationClientRecordTabs;
        } else if (customerType == CustomerType.Company) {
            tabs = CompanyClientRecordTabs;
        }
        return tabs;
    };

    public render(): JSX.Element {
        const { tabIndex, customerType, name } = this.state;
        const tabs = this.getTabArray(customerType);
        if (!customerType) {return null;}

        return (
            <div>
                <HeaderBar clientId={this.getCustomerId()} name={name} />

                <Tab
                    permission={this.pagePermission()}
                    tabs={tabs}
                    curTabIndex={tabIndex}
                    onClick={(tab) => {
                        this.setState({ tabIndex: tab });
                    }}
                />

                <div className="anim-navigation-wrapper">{this.getContent(tabIndex, this.getCustomerId())}</div>
            </div>
        );
    }

    private pagePermission = () => {
        const permission = new Map<ClientRecordTab, UserClaim>();
        permission.set(ClientRecordTab.AddressDetail, UserClaim.AdviserPortalCustomerPartialAccessCanView);
        permission.set(ClientRecordTab.PensionProtection, UserClaim.AdviserPortalCustomerPartialAccessCanView);
        permission.set(ClientRecordTab.PersonalDetail, UserClaim.AdviserPortalCustomerPartialAccessCanView);
        permission.set(ClientRecordTab.ContactDetail, UserClaim.AdviserPortalCustomerPartialAccessCanView);
        permission.set(ClientRecordTab.RegulatoryChecks, UserClaim.AdviserPortalCustomerFullyAccessCanView);
        permission.set(ClientRecordTab.Regulatory, UserClaim.AdviserPortalCustomerPartialAccessCanView);
        permission.set(ClientRecordTab.OrganisationDetails, UserClaim.AdviserPortalCustomerPartialAccessCanView);

        return permission;
    };
}
